import { LuChevronDown, LuSearch } from "@/Components/Icons/Icons.jsx";
// import { formattedEximCode } from "@/Constant/Common/Common";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "80%",
      rows: {
        row1: [
          {
            name: "exportProductGeneralEximCode",
            label: "Exim Code",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getEximCode",
            width: "50%",
            isWatchField: true,
          },
          {
            name: "exportProductGeneralNFEICategory",
            label: "NFEI Category",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            defaultValue: "cat",
            width: "50%",
            options: [
              { label: "NFEI", value: "NFEI" },
              { label: "BCCI", value: "BCCI" },
            ],
          },
        ],
        row2: [
          {
            name: "exportProductGeneralRewardItem",
            label: "Reward Item",
            component: "checkboxbox",
            sx: {
              width: "50%",
            },
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
          },
          {
            name: "exportProductGeneralSTRCode",
            label: "STR Code",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            disabled: true,
            width: "50%",
          },
        ],
        row3: [
          {
            name: "exportProductGeneralEndUse",
            label: "End Use",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getEndUseCode",
          },
          {
            name: "exportProductGeneralOriginDistrict",
            label: "Origin District",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getDistrictMaster",
            autofillTargets: {
              exportProductGeneralOriginState: "stateName",
            },
          },
        ],
        row4: [
          {
            name: "exportProductGeneralOriginState",
            label: "Origin State",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            disabled: true,
          },
          {
            name: "exportProductGeneralPTAFTAInfo",
            label: "PTA/FTA info",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getFTAMaster",
          },
        ],
        row5: [
          {
            name: "exportProductGeneralAlternateQtyUnit",
            label: "Alternate Qty",
            component: "text-field",
            width: "30%",
            dataType: "int",
          },
          {
            name: "exportProductGeneralAlternateQtyValue",

            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            width: "20%",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
          {
            name: "exportProductGeneralMaterialCode",
            label: "Material Code",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            width: "50%",
            disabled: true,
          },
        ],
        row6: [
          {
            name: "exportProductGeneralMedicinalPlant",
            label: "Medicinal Plant",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            disabled: true,
          },
          {
            name: "exportProductGeneralFormulation",
            label: "Formulation",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            disabled: true,
          },
        ],
        row7: [
          {
            name: "exportProductGeneralSurfaceMaterialInContact",
            label: "Surface Material in Contact",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            disabled: true,
          },
          {
            name: "exportProductGeneralLabGrownDiamond",
            label: "Lab Grown Diamond",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            defaultValue: "lab",
            disabled: true,
          },
        ],
        row8: [
          {
            name: "PVM Info",
            component: "header",
          },
        ],
        row9: [
          {
            name: "exportProductGeneralCurrency",
            label: "Currency",
            component: "text-field",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            width: "50%",
            endpoint: "getExchangeMasterId",
            type: "autocomplete",
            // defaultValue: "currency",
            // options: [
            //   { label: "INR", value: "INR" },
            //   { label: "USD", value: "USD" },
            // ],
          },
          {
            name: "exportProductGeneralCalcMethod",
            label: "Calc.Method",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            width: "30%",
            defaultValue: "cal",
            options: [
              { label: "%age", value: "%age" },
              { label: "Manual", value: "Manual" },
            ],
          },
          {
            name: "exportProductGeneralCalcAmount",
            component: "text-field",
            width: "20%",
            dataType: "int",
          },
        ],
        row10: [
          {
            name: "exportProductGeneralPMVPerUnit",
            label: "PMV/Unit",
            component: "text-field",
            dataType: "float",
          },
          {
            name: "exportProductGeneralPMVPerUnitCurrency",
            component: "text-field",
            disabled: true,
            width: "30%",
            isGet: false,
          },
          {
            name: "exportProductGeneralTotalPMV",
            label: "Total PVM",
            component: "text-field",
            dataType: "float",
          },
          {
            name: "exportProductGeneralTotalPMVCurrency",
            component: "text-field",
            width: "30%",
            disabled: true,
            isGet: false,
            // dataType:"int"
          },
        ],
        row11: [
          {
            name: "IGST & Compensation Cess Info",
            component: "header",
          },
        ],
        row12: [
          {
            name: "exportProductGeneralIGSTPymtStatus",
            label: "IGST Pymt Status",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            defaultValue: "igst",
            options: [
              { label: "Not Applicable", value: "Not Applicable" },
              { label: "Export Under Bond", value: "Export Under Bond" },
              { label: "Export Against Payment", value: "Export Against Payment" },
            ],
          },
          {
            name: "exportProductGeneralTaxableValueINR",
            label: "Taxable Value(INR)",
            component: "text-field",
            dependsOn: "exportProductGeneralIGSTPymtStatus",
            dataType: "float",
            dependsValue: ["Export Under Bond", "Export Against Payment"],
            placeholder: "0.00",

          },
        ],
        row13: [
          {
            name: "exportProductGeneralIGSTRate",
            label: "IGST Rate(%)",
            component: "text-field",
            dataType: "float",
            dependsValue: ["Export Against Payment"],
            dependsOn: "exportProductGeneralIGSTPymtStatus",
            placeholder: "0.00",
          },
          {
            name: "exportProductGeneralIGSTAmountINR",
            label: "IGST Amt(INR)",
            component: "text-field",
            dataType: "float",
            dependsValue: ["Export Against Payment"],
            dependsOn: "exportProductGeneralIGSTPymtStatus",
            placeholder: "0.00",
          },
        ],
        row14: [
          {
            name: "exportProductGeneralCompCess",
            label: "Comp.Cess(%)",
            component: "text-field",
            dataType: "float",
            dependsValue: ["Export Against Payment"],
            dependsOn: "exportProductGeneralIGSTPymtStatus",
            placeholder: "0.00",
          },
          {
            name: "exportProductGeneralCompCessAmountINR",
            label: "Comp.Cess Amt(INR)",
            component: "text-field",
            dataType: "float",
            dependsValue: ["Export Against Payment"],
            dependsOn: "exportProductGeneralIGSTPymtStatus",
            placeholder: "0.00",
          },
        ],
        row15: [
          {
            name: "RODTEP Info",
            component: "header",
          },
        ],
        row16: [
          {
            name: "exportProductGeneralRODTEPClaim",
            label: "RODTEP Claim",
            component: "dropdown",
            endIconName: "LuChevronDown",
            iconColor: "gray-400",
            width: "50%",
            defaultValue: "RODTEP",
            options: [
              { label: "YES", value: "YES" },
              { label: "NO", value: "NO" },
              { label: "Not Applicable", value: "Not Applicable" },
            ],
            
          },
          {
            name: "exportProductGeneralQuantityValue",
            label: "Quantity",
            component: "text-field",
            width: "30%",
            dataType: "float",
            dependsOn: "exportProductGeneralRODTEPClaim",
            dependsValue: ["YES"],
            placeholder: "0.00",


          },
          {
            name: "exportProductGeneralQuantityUnit",
            component: "text-field",
            icon: LuSearch,
            width: "20%",
            type: "autocomplete",
            endpoint: "getQuantity",
            dependsOn: "exportProductGeneralRODTEPClaim",
            dependsValue: ["YES"],
            placeholder: "0.00",


          },
        ],
        row17: [
          {
            name: "exportProductGeneralRatePercent",
            label: "Rate(in %)",
            component: "text-field",
            dataType: "float",
            dependsOn: "exportProductGeneralRODTEPClaim",
            dependsValue: ["YES"],
            placeholder: "0.00",
          },
          {
            name: "exportProductGeneralCapValue",
            label: "Cap Value",
            component: "text-field",
            dataType: "float",
            dependsOn: "exportProductGeneralRODTEPClaim",
            dependsValue: ["YES"],
            placeholder: "0.00",



          },
        ],
        row18: [
          {
            name: "exportProductGeneralCapValuePerUnitValue",
            label: "Cap value per units",
            component: "text-field",
            width: "27%",
            dataType: "float",
            dependsOn: "exportProductGeneralRODTEPClaim",
            dependsValue: ["YES"],
            placeholder: "0.00",


          },
          {
            name: "exportProductGeneralCapValuePerUnit",
            component: "text-field",
            width: "20%",
            placeholder: "NOS",
            disabled: true,
            isGet: false,
            dependsOn: "exportProductGeneralRODTEPClaim",
            dependsValue: ["YES"],

          },
          {
            name: "exportProductGeneralRODTEPAmountINR",
            label: "RODTEP Amount(INR)",
            component: "text-field",
            width: "50%",
            dataType: "float",
            disabled:true,
          },
        ],
      },
    },
  ],
};
